import { browserHistory } from 'react-router'
import qs from 'qs'
import {fromQueryObject} from '../utils/queryObjectMapper'
import R from 'ramda'

const extractQuery = (rawLocation) => {
  const parsedLocation = browserHistory.createLocation(rawLocation.hash.replace('#', ''))
  const search = parsedLocation.search
  const parsedQuery = qs.parse(search.replace('?', ''))
  return fromQueryObject(parsedQuery)  
}
const mExtractQuery = R.memoize(extractQuery)

export default () => {
  const rawLocation = window.location
  return mExtractQuery(rawLocation)
}





/** WEBPACK FOOTER **
 ** ./app/utils/getCurrentQuery.js
 **/